import { Injectable } from "@angular/core";
import { IID_ISSUE_LINK } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDIssueLinkStore } from "./iidIssueLink.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.ISSUE_LINK)
export class IIDIssueLinkQuery extends AbstractInterfaceDataQuery<IID_ISSUE_LINK> {
  constructor(protected store: IIDIssueLinkStore) {
    super(store);
  }
}
